import Week from './week'

const Weeks = ({ daysByWeek }) => (
  <>
    {
      daysByWeek.map(([weekStart, days]) => (
        <Week key={weekStart} weekStart={weekStart} days={days} />
      ))
    }
  </>
)

export default Weeks
